var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingBannerIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 100,
    viewBox: "0 0 343 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_10534)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 100,
    rx: 12,
    fill: "url(#paint0_linear_137_10534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.412 25.1103C118.412 25.0734 118.413 25.0369 118.413 25C118.413 4.98748 102.313 -11.2358 82.4528 -11.2358C67.7275 -11.2358 55.0715 -2.31575 49.5105 10.4532C48.0999 10.2085 46.6503 10.0795 45.1705 10.0795C31.1514 10.0795 19.7866 21.5313 19.7866 35.6577C19.7866 49.784 31.1514 61.2359 45.1705 61.2359H120.397C130.327 61.2359 138.377 53.1241 138.377 43.1178C138.377 33.1115 130.327 25 120.397 25C119.726 25 119.064 25.0382 118.412 25.1103Z",
    fill: "url(#paint1_linear_137_10534)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.051 89.4567C352.051 89.4136 352.053 89.371 352.053 89.3279C352.053 65.9508 333.246 47 310.047 47C292.846 47 278.062 57.4198 271.566 72.3355C269.918 72.0496 268.225 71.8989 266.496 71.8989C250.12 71.8989 236.845 85.276 236.845 101.777C236.845 118.279 250.12 131.656 266.496 131.656H354.37C365.969 131.656 375.372 122.18 375.372 110.492C375.372 98.8031 365.969 89.3279 354.37 89.3279C353.586 89.3279 352.813 89.3725 352.051 89.4567Z",
    fill: "url(#paint2_linear_137_10534)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_10534",
    x1: 0,
    y1: 0,
    x2: 9.04182,
    y2: 124.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_137_10534",
    x1: 79.0817,
    y1: 38.45,
    x2: 74.7854,
    y2: 7.32655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_137_10534",
    x1: 306.109,
    y1: 105.039,
    x2: 301.09,
    y2: 68.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_10534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 100,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingBannerIos);
export default __webpack_public_path__ + "static/media/pending_banner_ios.a726e6785a7943252d262005131396b7.svg";
export { ForwardRef as ReactComponent };